function ___$insertStyle(css) {
    if (!css || typeof window === 'undefined') {
        return;
    }
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}

var Status;

(function (Status) {
  Status["INVALID"] = "invalid";
  Status["VALID"] = "valid";
})(Status || (Status = {}));

export { Status };
